import React from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const BuyerQCFilter = ({
  variantId,
  setVariantId,
  buyerApp,
  setBuyerApp,
  category,
  setCategory,
  title,
  setTitle,
  issueType,
  setIssueType,
  issueTypes,
  buyerApps,
  createdAt,
  setCreatedAt,
}) => {

          // { console.log("options", buyerApps)}

  return (
    <div className="row">
      <div className="col-2">
        <label className="formLabels mb-1">Category</label>
        <input
          type="text"
          value={category}
          id="category"
          name="category"
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Search category"
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Title</label>
        <input
          type="text"
          value={title}
          id="title"
          name="title"
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Search tite "
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Buyer App </label>
        <select
          id="buyerApp"
          className="form-select"
          aria-label="Default select example"
          value={buyerApp}
          onChange={(e) => setBuyerApp(e.target.value)}
        >            
          <option value="">Select Option</option>
           {buyerApps && buyerApps.length
            ? buyerApps.map((domain) => {
                return <option value={domain}>{domain}</option>;
              })
            : null}
          
        </select>
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Variant Id</label>
        <input
          type="text"
          value={variantId}
          id="variantId"
          name="variantId"
          onChange={(e) => setVariantId(e.target.value)}
          placeholder="Search variant id"
          className="form-control"
        />
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Issue Type</label>
        <select
          id="issueType"
          className="form-select"
          aria-label="Default select example"
          value={issueType}
          onChange={(e) => setIssueType(e.target.value)}
        >
          <option value="">Select Option</option>
          {issueTypes && issueTypes.length
            ? issueTypes.map((domain) => {
                return <option value={domain}>{domain}</option>;
              })
            : null}
        </select>
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Start From</label>
        <input
          type="date"
          value={createdAt || ""}
          id="dateFrom"
          name="dateFrom"
          onChange={(e) => setCreatedAt(e.target.value)}
          className="form-control"
        />
      </div>
      {/* <div className="col-2">
        <label className="formLabels mb-1">Action</label>
        <select
          id="status"
          className="form-select"
          aria-label="Default select example"
          value={actionType}
          onChange={(e) => setActionType(e.target.value)}
        >
          <option value="">Select Option</option>
          {actionOptions && actionOptions.length
            ? actionOptions.map((action) => {
                return <option value={action}>{action}</option>;
              })
            : null}
        </select>
      </div>
      <div className="col-2">
        <label className="formLabels mb-1">Domain</label>
        <select
          id="domain"
          className="form-select"
          aria-label="Default select example"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
        >
          <option value="">Select Option</option>
          {domainOptions && domainOptions.length
            ? domainOptions.map((domain) => {
                return <option value={domain}>{domain.domain}</option>;
              })
            : null}
        </select>
      </div> */}

      {/* 
  <div className="col-2">
    <label className="formLabels mb-1">End To</label>
    <input
      type="date"
      value={endDate || ""}
      id="dateTo"
      name="dateTo"
      onChange={(e) => setEndDate(e.target.value)}
      className="form-control"
    />
  </div> */}
    </div>
  );
};

export default BuyerQCFilter;
